
import React from 'react';
import { StaticTimePicker } from "@mui/x-date-pickers";
import { useTranslation } from 'react-i18next';

  
export default function StaticTimePickerCustom(props) {
    const { t } = useTranslation();

      return (
        <StaticTimePicker
          {...props}
          slotProps={{ actionBar: { actions: [] } }}
          localeText={{toolbarTitle:t('select_time')}}
          minTime={props.minDate}
          maxTime={props.maxDate}
        />
      );
    };